import { connect } from 'react-redux';
import { Forms } from '../..';
import { IDataStorage } from '../../../core';
import { FxTranslate } from '../../../core/translate';
import { ICardEdit } from '../../../services/operaciones/model/ICardEdit';
import { Column, DataTable, InputSwitch, Panel, SelectButton } from '../../prime';
import { Secciones } from '../index.service';
import { Roles } from '../../../services/api/seguridad/model/IRol';
import Security from '../../../services/seguridad';
import { MonedaComboItem } from '../../../model/cobranza/MonedaComboItem';
import styles from './index.module.scss';
import CnetDropdown from '../../cnet/CnetDropdown';
import { IPais } from '../../../services/api/entity/model';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;

  paises?: IPais[] | null | undefined;
  monedas?: MonedaComboItem[] | null | undefined;
  
  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

function CardSeccionOperacion({ storage, t,
  data,
  paises, monedas,
  onUpdateFields,
} : IProps) {
  const onUpdateField = (field: string, value: any) => onUpdateFields([ { field, value }]);

  return <div className={styles["card-seccion-content"]}>
    <div className={styles["card-seccion-title"]}>{t(`Menu.${Secciones.Operacion}`)}</div>

      <div className='p-grid'>
        <div className='p-col-12 p-lg-6 p-p-2'>
          <Forms.Input 
            title={t("Seccion.Field.operacion.codigo")}
            className={styles["fix-form-component"]}
            value={`${data?.operacion?.codigo ?? data?.operacion?.numero}`}
            //onChange={(v,e) => onUpdateField('operacion.codigo', v)}
          />
        </div>
        <div className='p-col-12 p-lg-6 p-p-2'>
          <Forms.Calendar 
            title={t("Seccion.Field.operacion.creafecha")}
            className={styles["fix-form-component"]}
            disabled
            value={window.getDate(data?.operacion?.creafecha)}
            //onChange={(v,e) => onUpdateField('cotizacion.callme', v)}
          />
        </div>
        {!Security.HasOneRolOf([Roles.Agente, Roles.Counter]) && 
          <>
            <div className='p-col-12 p-lg-6 p-p-2'>
              <Panel 
                header={
                  <div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center' }}>
                    <InputSwitch 
                      checked={data?.operacion?.vip ?? false} 
                      onChange={e => onUpdateField('operacion.vip', e.target.value)} 
                      disabled={!!data?.operacion?.vip && !Security.HasOneRolOf([Roles.Admin, Roles.AdministradorMarca, Roles.Operador, Roles.Supervisor])} />
                    <span style={{ lineHeight: 1.7, marginLeft: 10 }}>{t("Col.vip.Titulo")}</span>
                  </div>
                }
                style={{ marginBottom: 20 }}
              >
                {!data?.operacion?.vip && <span style={{ fontSize: '0.8rem', color: 'var(--orange)' }}>{t("Col.vip.False")}</span>}
                {!!data?.operacion?.vip && <span style={{ fontSize: '0.8rem', color: 'var(--success)' }}>{t("Col.vip.True")}</span>}
              </Panel>
            </div>

            <div className='p-col-12 p-lg-6 p-p-2'>
              <Panel 
                header={
                  <div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center' }}>
                    <InputSwitch 
                      checked={data?.operacion?.pasajeroenviaje ?? false} 
                      onChange={e => onUpdateField('operacion.pasajeroenviaje', e.target.value)} 
                      disabled={!!data?.operacion?.pasajeroenviaje && !Security.HasOneRolOf([Roles.Admin, Roles.AdministradorMarca, Roles.Operador, Roles.Supervisor])} />
                    <span style={{ lineHeight: 1.7, marginLeft: 10 }}>{t("Col.pasajeroEnViaje.Titulo")}</span>
                  </div>
                }
                style={{ marginBottom: 20 }}
              >
                {!data?.operacion?.pasajeroenviaje && <span style={{ fontSize: '0.8rem', color: 'var(--orange)' }}>{t("Col.pasajeroEnViaje.False")}</span>}
                
                { !!data?.operacion?.pasajeroenviaje && 
                  <CnetDropdown
                    t={t}
                    title={t("Seccion.Field.operacion.pasajeroenviajeorigen")}
                    value={data?.operacion?.pasajeroenviajeorigen}
                    optionLabel="nombre" optionValue="id"
                    options={paises ?? []}
                    optionsTransform={(data) => [
                      ...data.sort((a,b) => (a?.nombre ?? '') > (b?.nombre ?? '') ? 1 : -1)
                    ]}
                    onChange={e => onUpdateField('operacion.pasajeroenviajeorigen', e.value)}
                  />
                }
              </Panel>
            </div>
          </>
        }

        
        <div className='p-col-12 p-lg-6 p-p-2'>
          <SelectButton 
            optionLabel="name" optionValue='code'
            value={data?.operacion?.esprecioneto ?? false} 
            unselectable={false}
            options={[{ name: t("Col.esPrecioNeto.bruto"), code: false },  { name: t("Col.esPrecioNeto.neto"), code: true }]}
          />
        </div>
      </div>

      <div className='p-grid'>
        <div className='p-col-12 p-lg-12 p-p-2'>
          <div className="datatable-responsive-demo">
            <DataTable 
              value={FixPreciosGrid(data?.operacionproductorecotizacion)}
              className="p-datatable-responsive-demo" style={{ fontSize: 12, whiteSpace: 'nowrap' }}
              rowClassName={row => ({ [styles['grid-currentdate']]: row.current })} /* !!row.creafecha ? "" : "" }*/
            >
              <Column field='creafecha' header={t("Seccion.Field.operacion.creafecha")} style={{ width: 110 }}
                body={r => <span style={{ whiteSpace: 'nowrap', fontSize: 12 }}>{window.format(r.creafecha, "dd/MM/yyyy HH:mm")}</span>}
              />
              <Column field='moneda' header={t("Seccion.Field.operacion.totalimportemoneda")} style={{ width: 80 }} />
              <Column field='monedacotizacion' header={t("Seccion.Field.operacion.monedacotizacion")} style={{ textAlign: 'right' }} />
              <Column field='totalproducto' header={t("Seccion.Field.operacion.producto")} style={{ textAlign: 'right' }} />
              <Column field='totaldescuentocotizador' header={t("Seccion.Field.operacion.descuentocotizador")} style={{ textAlign: 'right' }} />
              <Column field='totalcodigodescuento' header={t("Seccion.Field.operacion.codigodescuento")} style={{ textAlign: 'right' }} />
              <Column field='totalpromocion' header={t("Seccion.Field.operacion.promocion")} style={{ textAlign: 'right' }} />
              <Column field='totalupgrades' header={t("Seccion.Field.operacion.upgrades")} style={{ textAlign: 'right' }} />
              <Column field='total' header={t("Seccion.Field.operacion.total")} style={{ textAlign: 'right' }} />
              {/*<Column field='totalajuste' header={t("Seccion.Field.operacion.ajuste")} style={{ textAlign: 'right' }} />*/}
              <Column field='totalpagado' header={t("Seccion.Field.operacion.pagado")} style={{ textAlign: 'right' }} />
              <Column field='totalapagar' header={t("Seccion.Field.operacion.apagar")} style={{ textAlign: 'right' }} />
            </DataTable>
          </div>
        </div>
      </div>
      
      <div className='p-grid'>
        <div className={"p-col-12 p-p-2"}>
          <Forms.InputArea 
            title={t("Seccion.Field.operacion.motivoAnulacion")}
            className={styles["fix-form-component"]}
            value={data?.operacion?.motivoanulacion}
            onChange={(v,e) => onUpdateField('operacion.motivoAnulacion', v)}
            onlyBlurEvent
            height={75}
          />
        </div>
      </div>
  </div>;
}
export default connect((s:any) => ({ storage:s.main }))(CardSeccionOperacion);


function FixPreciosGrid(rows?: any[]) {
  if (!rows || rows.length < 1) return [];
  const curr = rows[0].creafecha;

  const data = rows.map(r => ({
    current: r.creafecha === curr,
    moneda: r.monedacodigo,
    monedacotizacion: r.monedacotizacion,
    totalproducto: r.totalproducto,
    totaldescuentocotizador: r.totaldescuentocotizador,
    totalcodigodescuento: r.totalcodigodescuento,
    totalpromocion: r.totalpromocion,
    totalupgrades: r.totalupgrades,
    total: r.total,
    totalajuste: r.totalajuste,
    totalapagar: r.totalapagar,
    totalpagado: r.totalpagado,
    creafecha: r.creafecha,
  }));

  if (rows[0].idmoneda !== 2) 
  {
    data.push(...rows.map(r => ({
      current: r.creafecha === curr,
      moneda: "USD",
      monedacotizacion: 1,
      totalproducto: r.totalproductousd,
      totaldescuentocotizador: r.totaldescuentocotizadorusd,
      totalcodigodescuento: r.totalcodigodescuentousd,
      totalpromocion: r.totalpromocionusd,
      totalupgrades: r.totalupgradesusd,
      total: r.totalusd,
      totalajuste: r.totalajusteusd,
      totalapagar: r.totalapagarusd,
      totalpagado: r.totalpagadousd,
      creafecha: r.creafecha,
    })));
  }
  
  return data.sort((a,b) => a.creafecha > b.creafecha ? -1 : 1);
}